import AccountCreation from "@/components/signup/account-creation";
import {
    SignupBackgroundLayout,
    JSMOverlayTemplate
} from "@/components/signup/layouts";
import { ServiceCollectionLogo } from "@/components/signup/utils";
import { experiments, ExperimentView } from "@/utils/experiment";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import {
    FreeForThreeAgentsText,
    GetStartedHeading,
    GetStartedText,
    Headings,
    SubHeading,
    YourPlanIncludesText,
    JSMGetStartedHeading,
    InputSubmitButton
} from "../components";

const LoggedOutContent = () => {
    const team26VisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );
    return (
        <>
            {team26VisualUpdates ? (
                <Headings
                    main={<GetStartedText productName="Service Collection" />}
                    sub={<FreeForThreeAgentsText />}
                />
            ) : (
                <>
                    <GetStartedHeading productName="Service Collection" />
                    <SubHeading>
                        <FreeForThreeAgentsText />
                    </SubHeading>
                </>
            )}
            <AccountCreation />
        </>
    );
};

const LoggedOutContentLofi = () => {
    const team26VisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );
    return (
        <>
            {team26VisualUpdates ? (
                <Headings
                    main={<JSMGetStartedHeading />}
                    sub={<YourPlanIncludesText />}
                />
            ) : (
                <>
                    <JSMGetStartedHeading />
                    <SubHeading>
                        <YourPlanIncludesText />
                    </SubHeading>
                </>
            )}
            <AccountCreation Input={<InputSubmitButton />} Submit={null} />
        </>
    );
};

export const LoggedOut = () => (
    <ExperimentView
        experiment={experiments.servCoLofiBackground}
        render={(value) =>
            value ? (
                <JSMOverlayTemplate size="sm">
                    <LoggedOutContentLofi />
                </JSMOverlayTemplate>
            ) : (
                <SignupBackgroundLayout
                    ProductLogo={<ServiceCollectionLogo />}
                    theme="yellow"
                >
                    <LoggedOutContent />
                </SignupBackgroundLayout>
            )
        }
    />
);
